import { ACTION_REWARD_INFO, ACTION_REWARD_INFO_ERROR, ACTION_REWARD_INFO_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getRewardInfoReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_REWARD_INFO:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_REWARD_INFO_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_REWARD_INFO_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}